<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import moment from "moment";
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import LoadingMessage from '../LoadingMessage.vue';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default {
  components: { Layout, PageHeader, Swal, Multiselect, LoadingMessage },
  data() {
    return {
      title: "Advanced Table",
      items: [
        { text: "Tables", href: "/" },
        { text: "Advanced", active: true }
      ],
      montoFormateado: '',
      isLoading:false,
      recibos:[],
      clientes:[],
      users:[],
      usersAll:[],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filtro: '',
      fields: [
        { key: "id", label:"Nº", sortable: true },
        { key: "fechaComprobante", label:"Fecha", sortable: true },
        { key: "rut", label:"Rut", sortable: true },
        { key: "recibide", label:"Recibí de", sortable: true },
        { key: "suma", label:"Total", sortable: true },
        { key: "tipopago", label:"Tipo de Pago", sortable: true },
        { key: "asignacion", label:"Asignación", sortable: true },
        { key: "accion", label:"Acción", sortable: true }
      ],
      datos:this.defaultDatos(),
      datos_editar:this.defaultDatosEditar(),
      contabilidad:this.defaultContabilidad(),
      contabilidad_ver:this.defaultContabilidad(),
      facturas:[],
      recibos2:[],
      recibos3:[],
      recibos4:[],
      totalRows2: 1,
      currentPage2: 1,
      perPage2: 10,
      pageOptions2: [10, 25, 50, 100],
      filtro2: '',
      fields2: [
        { key: "id", label:"Nº", sortable: true },
        { key: "fechaComprobante", label:"Fecha", sortable: true },
        { key: "rut", label:"Rut", sortable: true },
        { key: "recibide", label:"Recibí de", sortable: true },
        { key: "suma", label:"Total", sortable: true },
        { key: "tipopago", label:"Tipo de Pago", sortable: true },
        { key: "asignacion", label:"Asignación", sortable: true },
        { key: "accion", label:"Acción", sortable: true }
      ],
      info:{},
      observacion:{},
      obs:{},
      options:[
        { text:'Vigentes',value:'vigente' },
        { text:'No Vigentes',value:'novigente' },
        { text:'Todos',value:'todos' }
      ],
      selected:'vigente',
      ver:{},
      cliente:'',
      nventas:'',
      totalventas:'',
      comision:'',
      mostrar:false,
      mostrar_boton:true,
      windowWidth2: window.innerWidth,
      windowHeight2: window.innerHeight
    };
  },
  computed: {
    allFacturasRevisadas() {
      return this.info.facturas.every(factura => !factura.revisado);
    },
    rows() { return this.recibos.length; },
    rows2() { return this.recibos2.length; },
    aFavor() { return this.calcularAFavor(this.datos); },
    aFavor_editar() { return this.calcularAFavor(this.datos_editar,true); },
    sumaTotal() {
      this.datos.suma = this.calcSumaFacturas(this.datos.facturas);
      return this.datos.suma;
    },
    sumaTotal_editar() {
      this.datos_editar.suma = this.calcSumaFacturas(this.datos_editar.facturas);
      return this.datos_editar.suma;
    },
    suma() {
      return this.contabilidad.arreglo.reduce((total, id) => {
        const r = this.contabilidad.mismos.find(rr => rr.id === id);
        return r ? total + parseInt(r.suma) : total;
      }, 0);
    },
    filteredData() {
      return this.recibos.filter(item =>
        item.rut.toLowerCase().includes(this.filtro.toLowerCase()) ||
        item.recibide.toLowerCase().includes(this.filtro.toLowerCase())
      );
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredData.slice(start, start + this.perPage);
    },
    filteredData2() {
      return this.recibos2.filter((item) => {
          // Aquí puedes personalizar los campos a buscar
          return (
              item.rut.toLowerCase().includes(this.filtro2.toLowerCase()) ||
              item.recibide.toLowerCase().includes(this.filtro2.toLowerCase()) ||
              item.ncontable.toLowerCase().includes(this.filtro2.toLowerCase())
          );
      });
    },
    paginatedData2() {
      const start = (this.currentPage2 - 1) * this.perPage2;
      return this.filteredData2.slice(start, start + this.perPage2);
    },
    aPagar() { return this.calcularAPagar(this.datos); },
    aPagar_editar() { return this.calcularAPagar(this.datos_editar,true); }
  },
  beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
  mounted() {
    this.totalRows = this.items.length;
    this.totalRows2 = this.items.length;
    window.addEventListener('resize', this.handleResize);
  },
  watch: {
    // Sincronizar datos.mediopago.montoefectivo con el monto formateado
    'datos.mediopago.montoefectivo'(newVal) {
      newVal = newVal?.toString().replace(/[^0-9-]/g, '');
      newVal = parseInt(newVal,10);
      if(isNaN(newVal)){
        this.datos.mediopago.montoefectivo=0;
      };
      if(newVal){
        this.datos.mediopago.montoefectivo=newVal.toLocaleString("es-CL",{style:"currency",currency:"CLP"});
      }else{
        this.datos.mediopago.montoefectivo=0;
      }
    },
    'datos.mediopago.montotarjeta'(newVal) {
      newVal = newVal?.toString().replace(/[^0-9-]/g, '');
      newVal = parseInt(newVal,10);
      if(isNaN(newVal)){
        this.datos.mediopago.montotarjeta=0;
      };
      if(newVal){
        this.datos.mediopago.montotarjeta=newVal.toLocaleString("es-CL",{style:"currency",currency:"CLP"});
      }else{
        this.datos.mediopago.montotarjeta=0;
      }
    },
    'datos.mediopago.montowebpay'(newVal) {
      newVal = newVal?.toString().replace(/[^0-9-]/g, '');
      newVal = parseInt(newVal,10);
      if(isNaN(newVal)){
        this.datos.mediopago.montowebpay=0;
      };
      if(newVal){
        this.datos.mediopago.montowebpay=newVal.toLocaleString("es-CL",{style:"currency",currency:"CLP"});
      }else{
        this.datos.mediopago.montowebpay=0;
      }
    },
    'datos.mediopago.montoexcedente'(newVal) {
      newVal = newVal?.toString().replace(/[^0-9-]/g, '');
      newVal = parseInt(newVal,10);
      if(isNaN(newVal)){
        this.datos.mediopago.montoexcedente=0;
      };
      if(newVal){
        this.datos.mediopago.montoexcedente=newVal.toLocaleString("es-CL",{style:"currency",currency:"CLP"});
      }else{
        this.datos.mediopago.montoexcedente=0;
      }
    },
    'datos.mediopago.montotransferencia'(newVal) {
      newVal = newVal?.toString().replace(/[^0-9-]/g, '');
      newVal = parseInt(newVal,10);
      if(isNaN(newVal)){
        this.datos.mediopago.montotransferencia=0;
      };
      if(newVal){
        this.datos.mediopago.montotransferencia=newVal.toLocaleString("es-CL",{style:"currency",currency:"CLP"});
      }else{
        this.datos.mediopago.montotransferencia=0;
      }
    }
  },
  methods: {
    handleResize() {
        this.windowWidth2 = window.innerWidth;
        this.windowHeight2 = window.innerHeight;
    },
    // Consultar el correo del cliente
    async consultaCorreo(info) {
      this.$refs['modal-ver'].hide()
      try {
        // Obtener el correo asociado al cliente
        let data  = this.clientes.find(cli=>cli.rut==info.rut)
        let correoExistente = data.mail || ""; // Si no existe, estará vacío
        let correoGuardar = false; // Si no existe, estará vacío

        // Mostrar un input para confirmar o editar el correo
        const correo = await Swal.fire({
            title: "Enviar Recibo Electrónico",
            //color: "#2b2e8f",
            input: "email",
            inputValue: correoExistente,
            inputLabel: "Confirma o ingresa el correo del cliente",
            inputPlaceholder: "correo@example.com",
            showCancelButton: true,
            confirmButtonText: "Enviar",
            confirmButtonColor: "#2b2e8f",
            cancelButtonText: "Cancelar",
            reverseButtons: true, 
            inputValidator: (value) => {
              if (!value) return "Debe ingresar un correo válido.";
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(value)) return "El formato del correo no es válido.";
            },
        });

        if (correo.isConfirmed) {
            // Confirmar el envío del correo
            console.log(correo)
            const confirmacion = await Swal.fire({
              title: "Confirmar Envío",
              html: `
                  <p>¿Deseas enviar el recibo al correo: <strong>${correo.value}</strong>?</p>
                  <div>
                      <input type="checkbox" id="guardarCorreo" ${correoGuardar ? "checked" : ""}>
                      <label for="guardarCorreo">Guardar correo para cliente</label>
                  </div>
              `,
              icon: "question",
              showCancelButton: true,
              confirmButtonText: "Sí, enviar",
              confirmButtonColor: "#2b2e8f",
              cancelButtonText: "Cancelar",
              reverseButtons: true, 
              preConfirm: () => {
                  const guardarCorreo = document.getElementById("guardarCorreo").checked;
                  return { guardarCorreo };
              },
          });

            this.$refs['modal-ver'].show();
            this.info.correoGuardar=confirmacion.value.guardarCorreo;
            console.log(this.info);
            console.log(confirmacion);
            if (confirmacion.isConfirmed) {
                // Enviar el recibo
                setTimeout(() => {
                    console.log("Este mensaje aparece después de 0.1 segundos");
                    this.enviarPDF(info,correo.value)
                }, 100);
            }
        }
    } catch (error) {
        console.log(error)
        Swal.fire({
                    //position: "top-end",
                    icon: "error",
                    title: "Ocurrió un problema al procesar la solicitud.",
                    showConfirmButton: true,
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#2b2e8f",
                });
    }
    },
    enviarPDF(info,correo) {
        this.isLoading=true
        window.resizeTo(1024, 768); // Establece el tamaño de la ventana de escritorio

        // Forzar la vista de escritorio manipulando la metaetiqueta viewport
        let metaTag = document.querySelector('meta[name="viewport"]');
        metaTag.setAttribute('content', 'width=1024');
        const modalContent = this.$refs.ReciboContentPDF; // Captura el contenido del modal
        // Aplicar clase para ocultar elementos
        modalContent.classList.add('hide-elements');
        html2canvas(modalContent, { scale: 2 }).then(canvas => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgWidth = 210; // Ancho A4 en mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            const pdfBlob = pdf.output('blob');
            const formData = new FormData();
            formData.append('file', pdfBlob, `Recibo_${info.id}.pdf`);
            formData.append('email', correo); // Email del destinatariocorreo'informatica@alegoria.cl ,'doyarzun@vamproden.cl','ccarmona@vamproden.cl','epacheco@vamproden.cl'
            formData.append('nombre', info.recibide);
            formData.append('total', this.formatNumber(info.pago_sin_exedente));
            formData.append('id', info.id);
            formData.append('rut', info.rut);
            formData.append('guardarCorreo', info.correoGuardar);
            
            modalContent.classList.remove('hide-elements');
            // Restaurar la metaetiqueta viewport original
            metaTag.setAttribute('content', 'width=device-width, initial-scale=1');
            // Enviar al backend
            axios.post('/recibo_email_send', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                console.log('Correo enviado:', response.data);
                this.$bvToast.toast('Correo enviado exitosamente', {
                    title: 'Éxito',
                    variant: 'success',
                    solid: true
                });
                this.isLoading=false
            })
            .catch(error => {
                console.error('Error al enviar el correo:', error);
                this.$bvToast.toast('Error al enviar el correo', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
                this.isLoading=false
            });
        });
    },
    generarPDF(info) {
        window.resizeTo(1024, 768); // Establece el tamaño de la ventana de escritorio

        // Forzar la vista de escritorio manipulando la metaetiqueta viewport
        let metaTag = document.querySelector('meta[name="viewport"]');
        metaTag.setAttribute('content', 'width=1024');
        const modalContent = this.$refs.ReciboContentPDF; // Captura el contenido del modal
        // Aplicar clase para ocultar elementos
        modalContent.classList.add('hide-elements');
        html2canvas(modalContent, { scale: 2 }).then(canvas => {
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF('p', 'mm', 'a4');
          const imgWidth = 210; // Ancho A4 en mm
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
          pdf.save('Recibo_'+info.id+'.pdf');
          // Restaurar elementos visibles
          modalContent.classList.remove('hide-elements');
          // Restaurar la metaetiqueta viewport original
          metaTag.setAttribute('content', 'width=device-width, initial-scale=1');
        });

    },
    esUltimoRecibo(item) {
        const ultimoRecibo = this.recibos
            .filter(recibo => recibo.rut === item.rut)
            .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
        return ultimoRecibo && ultimoRecibo.id === item.id;
    },
    handleAceptar(recibo){
        this.mostrar = false;
        this.$refs['modal-ver'].hide()
    },
    defaultDatos(){
      return {
        fecha:'',
        rut:'',
        recibide:'',
        vendedor:'',
        facturas:[],
        asignacion:'no especifico',
        suma:'',
        pago:[],
        mediopago:{
          montoefectivo:'',
          cheque:[{ n: '', banco: '', montocheque:'', fecha:'' }],
          tipotarjeta:'',
          montotarjeta:'',
          tipowebpay:'',
          montowebpay:'',
          montotransferencia:'',
          montoexcedente:''
        },
        aPagar:'',
        aFavor:'',
        saldo:''
      };
    },
    defaultDatosEditar(){
      return {
        id:'',
        estado:'',
        fecha:'',
        rut:'',
        recibide:'',
        vendedor:'',
        facturas:[],
        asignacion:'no especifico',
        suma:'',
        pago:[],
        mediopago:{
          montoefectivo:'',
          cheque:[],
          tipotarjeta:'',
          montotarjeta:'',
          tipowebpay:'',
          montowebpay:'',
          montotransferencia:'',
          montoexcedente:''
        },
        aPagar:'',
        aFavor:'',
        saldo:''
      };
    },
    defaultContabilidad(){
      return {
        id:'',
        fechacontable:'',
        ncontable:'',
        boolfecha:false,
        booln:false,
        asignacion:'',
        mismos:[],
        arreglo:[],
        selectAll: false
      };
    },
    RecargarCliente(){
      this.onSelect(this.cliente);
    },
    calcSumaFacturas(facturas){
      return facturas.reduce((t, f) => t + parseInt(f.valor.toString().replace(/[^0-9-]/g, '') || 0), 0);
    },
    calcularAFavor(dataObj, editar=false){
      let suma = this.calcSumaFacturas(dataObj.facturas);
      let resta = dataObj.aPagar - suma;
      if(editar) this.repartirMontoEditar();
      else this.repartirMonto();
      return resta;
    },
    calcularAPagar(dataObj){
      let total=0;
      const mp=dataObj.mediopago;
      if (mp.montoefectivo) total+= parseInt(mp.montoefectivo.toString().replace(/[^0-9-]/g, ''));
      const sumacheques = mp.cheque?.reduce((acc, c) => acc + parseInt(c.montocheque.toString().replace(/[^0-9-]/g, '') || 0), 0) || 0;
      total+= sumacheques;
      if (mp.montotarjeta) total+= parseInt(mp.montotarjeta.toString().replace(/[^0-9-]/g, ''));
      if (mp.montowebpay) total+= parseInt(mp.montowebpay.toString().replace(/[^0-9-]/g, ''));
      if (mp.montotransferencia) total+= parseInt(mp.montotransferencia.toString().replace(/[^0-9-]/g, ''));
      dataObj.pago_sin_exedente=total;
      if (mp.montoexcedente) total+= parseInt(mp.montoexcedente.toString().replace(/[^0-9-]/g, ''));
      dataObj.aPagar=total;
      return total;
    },
    repartirMonto() {
      let restante = this.datos.aPagar;
      this.datos.facturas.forEach(f => {
        f.pago=0;
        if (restante > 0) {
          const espacio = parseInt(f.valor.toString().replace(/[^0-9-]/g, ''))-parseInt(f.pago);
          const aAsignar = Math.min(espacio, restante);
          f.pago += aAsignar;
          restante -= aAsignar;
        } else f.pago=0;
      });
    },
    repartirMontoEditar() {
      let restante = this.datos_editar.aPagar;
      this.datos_editar.facturas.forEach(f => {
        f.pago=0;
        if (restante > 0) {
          const espacio = parseInt(f.valor.toString().replace(/[^0-9-]/g, ''))-parseInt(f.pago);
          const aAsignar = Math.min(espacio, restante);
          f.pago += aAsignar;
          restante -= aAsignar;
        }else f.pago=0;
      });
    },
    labelselect_cat(cliente) { return `${cliente.rut}`; },
    onSelect(selected) {
      this.cliente = selected;
      Object.assign(this.datos,{rut:selected.rut,recibide:selected.nombre,vendedor:selected.vendedor,facturas:[],aPagar:0,bloqueado:selected.Bloqueado});
      this.isLoading=true;
      axios.post('/api/get_facturas_deudor',{ lote_id: this.lote, rut_id:this.cliente.rut_id }).then(res=>{
        this.facturas=res.data.facturas;
        selected.excedente=parseInt(res.data.excedente);
        console.log(this.facturas)
        this.cliente.excedente=parseInt(res.data.excedente);
        if (this.facturas.length>0) {
          this.facturas.forEach(e => {
            if(e.recibo==null && parseInt(e.saldo)>0){
              this.datos.facturas.push({ concepto:e.documento, valor:this.formatNumber(e.saldo),pago:e.pago, fecha:e.vence, activo:true, cli_estado:e.cli_estado, revisado:false});
            }
          });
        }else{ this.factura(); }
        this.isLoading=false;
        if(parseInt(selected.excedente)>0){
          this.datos.pago.push('excedente');
          this.datos.mediopago.montoexcedente=parseInt(selected.excedente);
        }else {
          this.datos.mediopago.montoexcedente=0;
        }
      });
    },
    onEnterSelect() {
      if (this.selectedProduct) this.onSelect(this.selectedProduct);
    },
    fecha(fechahora){ return moment(fechahora).format('DD-MM-YYYY'); },
    modal_recibo(){
      Object.assign(this.datos,this.defaultDatos(),{fecha:moment(new Date).format('YYYY-MM-DD')});
      this.cliente=[];
      this.$refs['modal-recibo'].show();
      setTimeout(()=>{ if (this.$refs.clienteMultiselect) this.$refs.clienteMultiselect.$refs.search.focus(); },100);
    },
    factura(){
      this.datos.facturas.push({ concepto:'', valor:'', pago:'', fecha:'', activo:false, cli_estado:'', revisado:false});
      Object.assign(this.datos.mediopago,{montoefectivo:'',montotarjeta:'',montotransferencia:'',montowebpay:'',montocheque:''});
      this.datos.aPagar=0;
    },
    factura_editar(){
      this.datos_editar.facturas.push({ concepto:'', valor:'', pago:'', fecha:'', activo:false, cli_estado:'', revisado:false  });
      Object.assign(this.datos_editar.mediopago,{montoefectivo:'',montotarjeta:'',montotransferencia:'',montowebpay:'',montocheque:''});
      this.datos_editar.aPagar=0;
    },
    eliminar(index){ this.datos.facturas.splice(index, 1); },
    eliminar_editar(index){ this.datos_editar.facturas.splice(index, 1); },
    msg(data){
      Swal.fire({ icon: "error", title: "Falta campo por completar", text: data, showConfirmButton: false, timer: 1500 });
    },
    validar(bvModalEvent) {
      const { fecha,fechaPago, rut, recibide, vendedor, facturas, aPagar, pago, mediopago } = this.datos;
      const validarCampo=(c,m)=>{ if(c){bvModalEvent.preventDefault();this.msg(m);return true;}return false; };
      const validarFactura=(p,v,m)=>{ if(p!=v.toString().replace(/[^0-9-]/g, '')){bvModalEvent.preventDefault();this.msg(m);return true;}return false; };
      if (validarCampo(!fecha,'Fecha Comprobante')) return;
      if (validarCampo(!fechaPago,'Fecha Pago')) return;
      if (validarCampo(!rut,'Rut')) return;
      if (validarCampo(!recibide,'Recibí de')) return;
      if (validarCampo(!vendedor,'Asignación')) return;
      if (validarCampo(!facturas.length,'Concepto de')) return;
      for (const { concepto, valor, pago, fecha } of facturas) {
          if(validarCampo(!concepto,'Nº de factura'))return;
          if(validarCampo(!valor,'Valor de factura'))return;
          if(validarCampo(!pago,'Pago de factura'))return;
          //if(validarCampo(!fecha,'Fecha de factura'))return;
          //if(validarFactura(pago,valor,'Factura Incompleta (Monto > Pago)'))return;
      }
      if (validarCampo(!aPagar,'A Pagar')) return;
      if (validarCampo(!pago.length,'Forma de pago')) return;
      if (pago.includes('cheque') && validarCampo(!mediopago.cheque?.length,'Faltan Datos del cheque')) return;
      if (pago.includes('tarjeta') && validarCampo(!mediopago.tipotarjeta,'Falta tipo de tarjeta')) return;
      if (pago.includes('webpay') && validarCampo(!mediopago.tipowebpay,'Falta tipo de webpay')) return;
      this.guardar_recibos();
      this.$refs['modal-recibo'].hide();
    },
    cancelar_recibos(){
      this.cliente='';
      Object.assign(this.datos,this.defaultDatos());
    },
    cancelar_recibos_editar(){
      Object.assign(this.datos_editar,this.defaultDatosEditar());
    },
    construirFormData(dataObj, editar=false){
      let fd = new FormData();
      if(editar) fd.append('id', dataObj.id);
      fd.append('fecha', dataObj.fecha);
      fd.append('fechaPago', dataObj.fechaPago);
      fd.append('rut', dataObj.rut);
      fd.append('recibide', dataObj.recibide);
      fd.append('vendedor', dataObj.vendedor);
      fd.append('asignacion', dataObj.asignacion);
      fd.append('facturas', JSON.stringify(dataObj.facturas));
      fd.append('suma', dataObj.suma);
      fd.append('aPagar', dataObj.aPagar);
      const afavor = editar?this.aFavor_editar:this.aFavor;
      if (afavor>0) { fd.append('aFavor', afavor); fd.append('saldo','0'); }
      else if(afavor<0){ fd.append('aFavor','0'); fd.append('saldo',afavor); }
      fd.append('pago', JSON.stringify(dataObj.pago));
      fd.append('mediopago', JSON.stringify(dataObj.mediopago));
      fd.append('pago_sin_exedente', dataObj.pago_sin_exedente);
      if(dataObj.estado) fd.append('estado', dataObj.estado);
      if(!editar) fd.append('lote_id', this.lote);
      return fd;
    },
    guardar_recibos(){
      let fd = this.construirFormData(this.datos,false);
      fd.append('creado_user_id', this.user.id);
      axios.post('/api/crear_recibos',fd).then(res=>{
        if(res.data.estado){
          Swal.fire({icon:"success", title:"Se ha creado el nuevo recibo con éxito", showConfirmButton:false,timer:1500});
          if(this.datos.vendedor!=this.user.name && this.datos.vendedor!=''){
            Swal.fire({icon:"success", title:"Recuerda que la comisión será para el vendedor asignado", showConfirmButton:false,timer:1500});
          }
          this.cancelar_recibos();
          this.actualizar();
        }
      });
    },
    editar_modal(item){
      this.cancelar_recibos_editar();
      Object.assign(this.datos_editar,{
        id:item.id,
        fecha:item.fecha,
        estado:item.estado,
        rut:item.rut,
        recibide:item.recibide,
        vendedor:item.vendedor,
        asignacion:item.asignacion,
        facturas:item.facturas,
        suma:item.suma,
        aPagar:item.aPagar||0,
        pago:item.pago||[],
        mediopago:item.mediopago
      });
      this.$refs['modal-recibo-editar'].show();
    },
    editar_recibos(){
      let fd = this.construirFormData(this.datos_editar,true);
      fd.append('editado_user_id', this.user.id);
      axios.post('/api/editar_recibos',fd).then(res=>{
        if(res.data.estado){
          Swal.fire({icon:"success", title:"Se ha editado con éxito", showConfirmButton:false,timer:1500});
          this.actualizar();
        }
      });
    },
    actualizar(){
      axios.get('/api/get_clientes').then(res=>{
        this.clientes=res.data.clientes;
        this.lote=res.data.lote;
        this.isLoading=false;
        this.usersAll=res.data.usersAll;
        console.log(this.usersAll)
      });
      axios.get('/api/get_recibos').then(res=>{
        this.users=res.data.users;
        this.user=res.data.user;
        if (this.user.rol=='Admin') {
          this.recibos=res.data.recibos.filter(r=>r.ncontable==null && r.estado=='vigente');
          this.recibos2=res.data.recibos.filter(r=>r.ncontable!=null || r.estado=='eliminado');
          this.recibos3=res.data.recibos.filter(r=>r.ncontable!=null || r.estado=='eliminado');
          this.recibos4=res.data.recibos_mes;
          this.filtro_tabla();
          var vigentes = this.recibos4.filter(r=>r.estado=='vigente');
        }else if(this.user.rol=='Vendedor'){
          const cond = r=>(r.vendedor==this.user.name||r.creado_user_id==this.user.id);
          this.recibos=res.data.recibos.filter(r=>r.ncontable==null && r.estado=='vigente' && cond(r));
          this.recibos2=res.data.recibos.filter(r=>(r.ncontable!=null || r.estado=='eliminado') && cond(r));
          this.recibos3=res.data.recibos.filter(r=>(r.ncontable!=null || r.estado=='eliminado') && cond(r));
          this.recibos4=res.data.recibos_mes.filter(r=>cond(r));
          var vigentes = this.recibos4.filter(r=>r.estado=='vigente');
        }
        this.nventas= vigentes.length;
        let total = vigentes.reduce((acc,e)=>acc+parseInt(e.suma),0);
        this.totalventas=total;
        if (this.user.comision) {
          this.comision = this.totalventas*(parseInt(this.user.comision)/100);
        }
      });
      this.factura();
    },
    contabilidad_modal(item){
      console.log(item)
      let cliente  = this.clientes.find(cli=>cli.rut==item.rut)
      let bloqueado=false
      item.facturas.forEach(fact => {
        if(fact.cli_estado=='CLIENTE BLOQUEADO'){
          bloqueado=true
        }
      });
      Object.assign(this.contabilidad,{
        id:item.id,
        fechacontable:item.fechacontable,
        ncontable:item.ncontable,
        asignacion:item.asignacion,
        boolfecha:item.ncontable!=null,
        booln:item.ncontable!=null,
        arreglo:[],
        bloqueado:bloqueado
      });
      this.contabilidad.mismos=this.recibos.filter(r=>r.fecha===item.fecha && r.asignacion===item.asignacion);
      this.contabilidad.selectAll=true; 
      this.toggleAll();
      this.$refs['modal-contabilidad'].show();
    },
    vali_contabilidad(bvModalEvent){
      if(!this.contabilidad_ver.fechacontable){this.msg('Fecha Contable');return;}
      if(!this.contabilidad_ver.ncontable){this.msg('Número Contable');return;}
      this.guar_contabilidad();
    },
    guar_contabilidad(){
      let fd = new FormData();
      fd.append('id', this.contabilidad_ver.id);
      fd.append('fechacontable', this.contabilidad_ver.fechacontable);
      fd.append('ncontable', this.contabilidad_ver.ncontable);
      fd.append('editado_user_id', this.user.id);
      axios.post('/api/guar_contabilidad',fd).then(res=>{
        if(res.data.estado){
          console.log('info_facturas');
          console.log(this.info);
          let cliente_factura = this.clientes.find(cli=>cli.rut==this.info.rut)
          this.info.fechacontable=this.contabilidad_ver.fechacontable;
          this.info.ncontable=this.contabilidad_ver.ncontable;
          Object.assign(this.contabilidad_ver,this.defaultContabilidad());
          this.mostrar=false;
          this.mostrar_boton=false;
          if (cliente_factura.Bloqueado=='S') {
            Swal.fire({
                icon: 'warning',
                title: 'Recuerde que debe desbloquear al cliente',
                //text: `Por favor, completa el campo "${campo}".`,
                showConfirmButton: true,
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#2b2e8f",
              }).then((result) => {
                if (result.isConfirmed) {
                  Swal.fire({
                    title: "Se ha guardado con éxito los datos",
                    text: "",
                    icon: "success",
                    showConfirmButton: false,
                    timer:1500
                  });
                }
              });
          }
          //Swal.fire({icon:"success",title:"Se ha guardado con éxito los datos",showConfirmButton:false,timer:1500});
          this.$refs['modal-ver'].hide()
          this.actualizar();
        }
      });
      try {
        axios.post('/api/update_recibos', this.info).then(response => {
            console.log('Recibo actualizado:', response.data.data);
        })
        this.mostrar=false;
      } catch (error) {
          console.error('Error al actualizar el recibo:', error);
          this.mostrar=false;
      }
    },
    validacion_contabilidad(bvModalEvent){
      if(!this.contabilidad.fechacontable){bvModalEvent.preventDefault();this.msg('Fecha Contable');return;}
      if(!this.contabilidad.ncontable){bvModalEvent.preventDefault();this.msg('Número Contable');return;}
      this.guardar_contabilidad();
    },
    guardar_contabilidad(){
      let fd = new FormData();
      fd.append('id', this.contabilidad.id);
      fd.append('fechacontable', this.contabilidad.fechacontable);
      fd.append('ncontable', this.contabilidad.ncontable);
      fd.append('arreglo', this.contabilidad.arreglo);
      fd.append('editado_user_id', this.user.id);
      axios.post('/api/guardar_contabilidad',fd).then(res=>{
        if(res.data.estado){
          Swal.fire({icon:"success",title:"Se ha guardado con éxito los datos",showConfirmButton:false,timer:1500});
          Object.assign(this.contabilidad,this.defaultContabilidad());
          this.$refs['modal-ver'].hide();
          this.actualizar();
          //this.$refs['modal-ver'].show();
        }
      });
    },
    modal_observacion(item){
      this.observacion=item;
      this.$refs['modal-observacion'].show();
    },
    eliminar_recibo(){
      let item = this.observacion;
      let fd = new FormData();
      fd.append('id', item.id);
      fd.append('observacion', item.observacion);
      fd.append('editado_user_id', this.user.id);
      axios.post('/api/eliminar_recibo',fd).then(res=>{
        if(res.data.estado){
          Swal.fire({icon:"success",title:"El recibo se ha eliminado",showConfirmButton:false,timer:1500});
          this.actualizar();
        }
      });
    },
    toggleAll() {
      if(this.contabilidad.selectAll) this.contabilidad.arreglo = this.contabilidad.mismos.map(r => r.id);
      else this.contabilidad.arreglo = [this.contabilidad.id];
    },
    checkIfAllSelected() {
      this.contabilidad.selectAll=(this.contabilidad.arreglo.length===this.contabilidad.mismos.length);
    },
    ver_modal(item){
      this.info=item;
      this.contabilidad_ver.id=item.id;
      if (this.info.ncontable!=null) {
        this.mostrar_boton=false;
      }
      this.$refs['modal-ver'].show();
    },
    capitalizarPrimeraLetra(text) {
      if(!text) return '';
      return text.charAt(0).toUpperCase()+text.slice(1);
    },
    modal_obs(item){
      this.obs=item;
      this.$refs['modal-obs'].show();
    },
    filtro_tabla(){
      if (this.selected=='vigente') this.recibos2=this.recibos3.filter(r=>r.estado=='vigente');
      else if(this.selected=='novigente') this.recibos2=this.recibos3.filter(r=>r.estado=='eliminado' || r.estado=='nulo');
      else if(this.selected=='todos') this.recibos2=this.recibos3;
    },
    modal_ver_obs(item){
      this.ver=item;
      this.$refs['modal-ver-obs'].show();
    },
    cambio_pago(){ this.limpiarMedioPago(this.datos); },
    cambio_pago_editar(){ this.limpiarMedioPago(this.datos_editar); },
    limpiarMedioPago(dataObj){
      const p=dataObj.pago,mp=dataObj.mediopago;
      if(!p.includes('efectivo')) mp.efectivo=[];mp.montoefectivo='';
      if(!p.includes('cheque')) mp.cheque=[];
      if(!p.includes('tarjeta')) mp.tipotarjeta='';mp.montotarjeta='';
      if(!p.includes('webpay')) mp.tipowebpay='';mp.montowebpay='';
    },
    formatNumber(num) {
      num = num?.toString().replace(/[^0-9-]/g, '');
      num = parseInt(num,10);
      if(isNaN(num)) return 0;
      return num?num.toLocaleString("es-CL",{style:"currency",currency:"CLP"}):'$0';
    },
    format_facturaValor(){
      this.datos.facturas.forEach(fact => {
        fact.valor = fact.valor?.toString().replace(/[^0-9-]/g, '');
        fact.valor = parseInt(fact.valor,10);
        fact.valor = fact.valor?fact.valor.toLocaleString("es-CL",{style:"currency",currency:"CLP"}):'$0';
      });
    },
    formatNumberInput(num) {
        num = num.toString().replace(/[^0-9-]/g, '');
        num = parseInt(num, 10);
        if (isNaN(num)) return '$0';
        return num.toLocaleString("es-CL", {
            style: "currency",
            currency: "CLP",
            minimumFractionDigits: 0
        });
    },
    obser(){
      let item = this.obs;
      let fd = new FormData();
      fd.append('id', item.id);
      fd.append('observacion', item.observacion);
      fd.append('editado_user_id', this.user.id);
      axios.post('/api/anular_recibo',fd).then(res=>{
        if(res.data.estado){
          Swal.fire({icon:"success",title:"El recibo se ha anulado",showConfirmButton:false,timer:1500});
          this.actualizar();
        }
      });
    },
    created(){
      this.isLoading=true;
      this.actualizar();
    },
    agregar_input(){
        this.mostrar=true;
        this.mostrar_boton=false;
    }
  },
  created(){
    this.isLoading=true;
    this.actualizar();
  }
};
</script>

<template>
<Layout>
    <PageHeader :title="title" :items="items" />
    <loading-message v-if="isLoading"/>
    <div class="row">
        <!-- <div :class="user.rol=='Vendedor'?'col-md-4':'offset-md-2 col-md-4'">
        <div class="card mini-stats-wid">
            <div class="card-body">
            <div class="media">
                <div class="media-body">
                <p class="text-muted font-weight-medium">Nº recibos</p>
                <h4 class="mb-0">{{ nventas }}</h4>
                </div>
                <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                <span class="avatar-title"><i class="bx bx-trending-up font-size-24"></i></span>
                </div>
            </div>
            </div>
        </div>
        </div>
        <div :class="user.rol=='Vendedor'?'col-md-4':'col-md-4'">
        <div class="card mini-stats-wid">
            <div class="card-body">
            <div class="media">
                <div class="media-body">
                <p class="text-muted font-weight-medium">Total</p>
                <h4 class="mb-0">{{ formatNumber(totalventas) }}</h4>
                </div>
                <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                <span class="avatar-title"><i class="bx bx-dollar-circle font-size-24"></i></span>
                </div>
            </div>
            </div>
        </div>
        </div>
        <div class="col-md-4" v-if="user.rol=='Vendedor'">
        <div class="card mini-stats-wid">
            <div class="card-body">
            <div class="media">
                <div class="media-body">
                <p class="text-muted font-weight-medium">Comisión</p>
                <h4 class="mb-0">{{ formatNumber(comision) }}</h4>
                </div>
                <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                <span class="avatar-title"><i class="bx bx-copyright font-size-24"></i></span>
                </div>
            </div>
            </div>
        </div>
        </div> -->
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <h4 class="card-title" v-if="windowWidth2>576">Recibos Electrónicos</h4>
                    <h3 v-else>Recibos Electrónicos</h3>
                    <div class="row mt-3">
                        <div :class="windowWidth2>576?'offset-md-6 col-md-6 text-right':'col-md-12'">
                            <b-button :class="windowWidth2>576?'':'mt-2'" variant="primary" :size="windowWidth2>576?'sm':'lg'" @click="modal_recibo()">Agregar Recibo</b-button>
                            <!-- Modal crear recibo -->
                            <b-modal ref="modal-recibo" title="Agregar recibo" size="lg" ok-title="Guardar" cancel-title="Cancelar" @ok="validar" @cancel="cancelar_recibos">
                                <div class="text-center"><loading-message v-if="isLoading" /></div>
                                <div class="row">
                                    <div class="col-md-10 col-sm-12">
                                        <div class="row">
                                            <div class="col-md-6 px-0">
                                                <b-form-group class="text-left" label="Fecha Comprobante:">
                                                    <b-form-input type="date" v-model="datos.fecha"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-6 px-0">
                                                <b-form-group  class="text-left" label="Fecha Pago:">
                                                <b-form-input type="date" v-model="datos.fechaPago"></b-form-input>
                                                </b-form-group>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 px-0">
                                        <b-form-group  class="text-left" label="Rut Cliente:">
                                            <multiselect v-if="clientes" ref="clienteMultiselect" 
                                                selectLabel="Seleccionar" 
                                                selectedLabel="Seleccionado" 
                                                deselectLabel="Remover" 
                                                placeholder="Selecciona un cliente"  
                                                track-by="rut" 
                                                v-model="cliente" 
                                                :options="clientes" 
                                                :custom-label="labelselect_cat" 
                                                :searchable="true" 
                                                :filterable="true" 
                                                @select="onSelect" 
                                                @keydown.native.enter="onEnterSelect"
                                            >
                                                <template v-slot:noOptions><p>No hay opciones</p></template>
                                                <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                            </multiselect>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-1 mt-4 ocultar">
                                        <b-button class="mt-1" variant="info" @click="RecargarCliente()" title="Cargar Facturas"><i class="bx bx-sync"></i></b-button>
                                    </div>
                                    <div class="col-md-8 px-0">
                                        <b-form-group class="text-left" label="Recibí de:">
                                        <b-form-input v-model="datos.recibide"></b-form-input>
                                        <p class="text-secondary font-size-10" v-if="datos.vendedor!=''">El vendedor asignado es {{ datos.vendedor }}</p>
                                        <p class="text-secondary font-size-10" v-else>No hay vendedor asignado</p>
                                        <p class="text-secondary font-size-10 text-danger" v-if="datos.bloqueado=='S'"><strong>¡Atención el cliente está Bloqueado!</strong></p>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-12 text-left px-0">
                                        <b-form-group label="Asignación:">
                                        <select v-model="datos.vendedor" class="form-control" :disabled="!!datos.vendedor">
                                            <option disabled value="">Seleccione una opción</option>
                                            <option v-for="(u, i) in users" :key="i" :value="u.name">{{u.name}}</option>
                                        </select>
                                        </b-form-group>
                                    </div>
                                    <label :class="windowWidth2>576?'col-md-12 text-left':'col-md-12 text-left mt-4 font-size-16'">Por Concepto de:</label>
                                    <div class="col-md-12 text-left" :style="windowWidth2>576?'':'background-color: #f8f9fa;padding:20px; margin: 0px;'">
                                        <div class="row text-center mt-3 ocultar" v-if="datos.facturas.length>0">
                                            <div class="col-md-3 p-1">
                                                <label>Nº Factura</label>
                                            </div>
                                            <div class="col-md-2 p-1">
                                                <label>Monto</label>
                                            </div>
                                            <div class="col-md-2 p-1">
                                                <label>Paga</label>
                                            </div>
                                            <div class="col-md-3 p-1">
                                                <label>Vencimiento</label>
                                            </div>
                                            <div class="col-md-1"></div>
                                        </div>
                                        <div class="row" v-for="(factura, index) in datos.facturas" :key="index">
                                            <div class="col-md-3 p-1">
                                                <label class="ocultar-lg">Nº Factura</label>
                                                <b-form-input :disabled="factura.activo" v-model="factura.concepto"></b-form-input>
                                            </div>
                                            <div class="col-md-2 p-1">
                                                <label class="ocultar-lg">Monto</label>
                                                <b-form-input :disabled="factura.activo" v-model="factura.valor" @input="format_facturaValor"></b-form-input>
                                            </div>
                                            <div class="col-md-2 p-1">
                                                <label class="ocultar-lg">Paga</label>
                                                <p class="form-control" :class="factura.pago==factura.valor.toString().replace(/[^0-9-]/g, '')?'border-success bg-success-light':'border-danger bg-danger-light'">
                                                    {{ formatNumber(factura.pago) }}
                                                </p>
                                            </div>
                                            <div class="col-md-3 p-1">
                                                <label class="ocultar-lg">Vencimiento</label>
                                                <b-form-input type="date" v-model="factura.fecha"></b-form-input>
                                            </div>
                                            <div :class="windowWidth2>576?'col-md-1':'col-md-12 text-center'">
                                                <b-button variant="danger" :size="windowWidth2>576?'':'lg'" @click="eliminar(index)"><i class="bx bx-trash" v-if="windowWidth2>576"></i><p class="m-0 p-0" v-if="windowWidth2<576">Eliminar</p></b-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div :class="windowWidth2>576?'col-md-12 text-center':'col-md-12 text-center mt-3'">
                                        <b-button variant="primary" :size="windowWidth2>576?'sm':'lg'" @click="factura()">Agregar concepto</b-button>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-12 text-left">
                                        <h5 v-if="windowWidth2>576">Medios de Pago</h5>
                                        <h4 v-else>Medios de Pago</h4>
                                        <b-form-checkbox-group stacked v-model="datos.pago" @change="cambio_pago">
                                            <b-form-checkbox value="efectivo" >
                                                <p :class="windowWidth2>576?'p-0 m-0':'p-0 m-0 font-size-18'">Efectivo</p>
                                            </b-form-checkbox>
                                            <div class="row" v-if="datos.pago.includes('efectivo')">
                                                <div class="col-md-4">
                                                <b-form-group label="Monto :">
                                                    <b-form-input v-model="datos.mediopago.montoefectivo"></b-form-input>
                                                </b-form-group>
                                                </div>
                                            </div>
                                            <b-form-checkbox value="cheque">
                                                <p :class="windowWidth2>576?'p-0 m-0':'p-0 m-0 font-size-18'">Cheque</p>
                                            </b-form-checkbox>
                                            <div class="row mb-2" v-for="(ch, i) in datos.mediopago.cheque" :key="i" v-show="datos.pago.includes('cheque')" :style="windowWidth2>576?'':'background-color: #f8f9fa;padding:20px; margin: 0px;'">
                                                <div class="col-md-2"><b-form-group label="Nº :"><b-form-input v-model="ch.n"></b-form-input></b-form-group></div>
                                                <div class="col-md-3"><b-form-group label="Banco :"><b-form-input v-model="ch.banco"></b-form-input></b-form-group></div>
                                                <div class="col-md-3"><b-form-group label="Monto :"><b-form-input v-model="ch.montocheque"></b-form-input></b-form-group></div>
                                                <div class="col-md-3"><b-form-group label="Fecha :"><b-form-input type="date" v-model="ch.fecha"></b-form-input></b-form-group></div>
                                                <div :class="windowWidth2>576?'col-md-1 mt-3 pt-1':'col-md-12 pt-1 text-center'">
                                                    <b-button variant="danger" @click="datos.mediopago.cheque.splice(i,1)">
                                                        <i class="bx bx-trash" v-if="windowWidth2>576"></i>
                                                        <p class="m-0 p-0" v-if="windowWidth2<576">Eliminar cheque</p>
                                                    </b-button>
                                                </div>
                                            </div>
                                            <div :class="windowWidth2>576?'row':'row my-3'" v-if="datos.pago.includes('cheque')">
                                                <div class="col-md-12 text-center">
                                                    <b-button variant="primary" :size="windowWidth2>576?'sm':'lg'" @click="datos.mediopago.cheque.push({ n:'',banco:'',montocheque:'',fecha:'' })">Agregar cheque</b-button>
                                                </div>
                                            </div>
                                            <b-form-checkbox value="tarjeta">
                                                <p :class="windowWidth2>576?'p-0 m-0':'p-0 m-0 font-size-18'">Tarjeta</p>
                                            </b-form-checkbox>
                                            <div :class="windowWidth2>576?'row mb-2':'row mt-3'" v-if="datos.pago.includes('tarjeta')">
                                                <div :class="windowWidth2>576?'col-md-12':'col-md-12 mb-2'">
                                                    <b-form-radio-group v-model="datos.mediopago.tipotarjeta">
                                                        <b-form-radio value="credito">Crédito</b-form-radio>
                                                        <b-form-radio value="debito">Débito</b-form-radio>
                                                    </b-form-radio-group>
                                                </div>
                                                <div class="col-md-4">
                                                    <b-form-group label="Monto :"><b-form-input v-model="datos.mediopago.montotarjeta"></b-form-input></b-form-group>
                                                </div>
                                            </div>
                                            <b-form-checkbox value="webpay">
                                                <p :class="windowWidth2>576?'p-0 m-0':'p-0 m-0 font-size-18'">Webpay</p>
                                            </b-form-checkbox>
                                            <div :class="windowWidth2>576?'row mb-2':'row mt-3'" v-if="datos.pago.includes('webpay')">
                                                <div :class="windowWidth2>576?'col-md-12':'col-md-12 mb-2'">
                                                    <b-form-radio-group v-model="datos.mediopago.tipowebpay">
                                                        <b-form-radio value="credito">Crédito</b-form-radio>
                                                        <b-form-radio value="debito">Débito</b-form-radio>
                                                    </b-form-radio-group>
                                                </div>
                                                <div class="col-md-4">
                                                    <b-form-group label="Monto :"><b-form-input v-model="datos.mediopago.montowebpay"></b-form-input></b-form-group>
                                                </div>
                                            </div>
                                            <b-form-checkbox value="transferencia">
                                                <p :class="windowWidth2>576?'p-0 m-0':'p-0 m-0 font-size-18'">Transferencia</p>
                                            </b-form-checkbox>
                                            <div class="row" v-if="datos.pago.includes('transferencia')">
                                                <div class="col-md-4">
                                                <b-form-group label="Monto :"><b-form-input v-model="datos.mediopago.montotransferencia"></b-form-input></b-form-group>
                                                </div>
                                            </div>
                                            <b-form-checkbox value="excedente">
                                                <p :class="windowWidth2>576?'p-0 m-0':'p-0 m-0 font-size-18'">Excedente anterior</p>
                                            </b-form-checkbox>
                                            <div class="row" v-if="datos.pago.includes('excedente')">
                                                <div class="col-md-4">
                                                <b-form-group label="Monto :"><b-form-input v-model="datos.mediopago.montoexcedente"></b-form-input></b-form-group>
                                                </div>
                                            </div>
                                        </b-form-checkbox-group>
                                    </div>
                                    <div class="offset-md-9 col-md-3 text-right" v-if="datos.facturas.length>0">
                                        <div :class="windowWidth2>576?'input-group':'input-group mt-4'">
                                            <div class="input-group-text bg-primary text-white">A Pagar</div>
                                            <p class="form-control">{{ formatNumber(aPagar) }}</p>
                                        </div>
                                        <br>
                                        <div :class="windowWidth2>576?'input-group':'input-group mt-2'">
                                            <div class="input-group-text bg-blue-light text-white">Saldo</div>
                                            <p class="form-control">{{ formatNumber(aFavor) }}</p>
                                        </div>
                                        <div :class="windowWidth2>576?'input-group':'input-group mt-2'">
                                            <div class="input-group-text bg-blue-light text-white">Total</div>
                                            <p class="form-control">{{ formatNumber(sumaTotal) }}</p>
                                        </div>
                                    </div>
                                </div>
                            </b-modal>
                        </div>
                        <h4 class="col-md-12 mt-5">Recibos no Contabilizados</h4>
                    </div>
                    <div class="row mt-4">
                        <div class="col-sm-12 col-md-6">
                            <div class="dataTables_length">
                                <label class="d-inline-flex align-items-center">
                                Mostrar&nbsp;<b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="dataTables_filter text-md-right">
                                <label class="d-inline-flex align-items-center">
                                Buscar:<b-form-input v-model="filtro" type="search" placeholder="Buscar..." class="form-control form-control-sm ml-2"></b-form-input>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive mb-0 ">
                        <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="ocultar" style="width: 5%;">Nº</th>
                                <th style="width: 11%;">Fecha</th>
                                <th class="ocultar" style="width: 10%;">Creado por</th>
                                <th class="ocultar" style="width: 10%;">RUT</th>
                                <th style="width: 30%;">Recibi</th>
                                <!-- <th style="width: 10%;">Total</th> -->
                                <th class="ocultar" style="width: 10%;">Tipo de Pago</th>
                                <th class="ocultar" style="width: 10%;">Asignación</th>
                                <th style="width: 20%;">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in paginatedData" :key="item.id">
                            <td class="ocultar">{{ item.id }}</td>
                            <td>{{ item.fechaComprobante }}</td>
                            <td class="ocultar">{{ usersAll.find(u=>u.id==item.creado_user_id)?.name||'' }}</td>
                            <td class="ocultar">{{ item.rut }}</td>
                            <td>{{ item.recibide }}</td>
                            <!-- <td>{{ formatNumber(item.suma) }}</td> -->
                            <td class="ocultar" ><p class="m-0" v-for="(p,i) in item.pago" :key="i">{{ p }}</p></td>
                            <td class="ocultar">{{ item.asignacion }}</td>
                            <td>
                                <b-button class="ocultar-lg" variant="primary" @click="ver_modal(item)" size="sm" :disabled="item.ncontable!=null"><i class="bx bx-cog"></i></b-button>
                                <b-button class="ocultar" variant="primary" @click="ver_modal(item)" size="sm" :disabled="item.ncontable!=null">Opciones</b-button>
                                <b-button :variant="item.ncontable==null?'danger':'success'" :disabled="item.facturas.some(factura => !factura.revisado)" @click="contabilidad_modal(item)" size="sm" v-if="(user.rol=='Admin' || user.id==6) && false">Contabilidad</b-button>
                                <!-- <b-button variant="danger" @click="modal_observacion(item)" size="sm" :disabled="item.ncontable!=null"><i class="bx bx-trash"></i></b-button> -->
                                <b-button 
                                variant="danger" 
                                @click="modal_observacion(item)" 
                                size="sm" 
                                :disabled="!esUltimoRecibo(item)" 
                                >
                                    <i class="bx bx-trash"></i>
                                </b-button>
                            </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                    <div class="row d-none d-lg-block">
                        <div class="col">
                        <div class="float-right">
                            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                        </div>
                        </div>
                    </div>
                    <b-modal ref="modal-observacion" no-close-on-backdrop title="Observación" ok-title="Guardar" cancel-title="Cancelar" @ok="eliminar_recibo">
                        <b-form-textarea v-model="observacion.observacion" rows="3" max-rows="6"></b-form-textarea>
                    </b-modal>
                    <b-modal ref="modal-recibo-editar" title="Ver recibo" size="lg" close-btn hide-footer>
                    <!-- <b-modal ref="modal-recibo-editar" title="Ver recibo" size="lg" hide-footer ok-title="Editar" :ok-disabled="true" cancel-title="Cancelar" @ok="editar_recibos"> -->
                        <div class="row">
                            <div class="offset-md-6 col-md-6 form-row">
                                <div class="col-md-6">
                                    <b-form-group label="Estado:">
                                        <select v-model="datos_editar.estado" class="form-control">
                                            <option disabled value="">Seleccione un estado</option>
                                            <option value="vigente">Vigente</option>
                                            <option value="nulo">Nulo</option>
                                        </select>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Fecha:">
                                    <b-form-input type="date" v-model="datos_editar.fecha"></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <b-form-group label="Rut:">
                                    <b-form-input v-model="datos_editar.rut"></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                            <b-form-group label="Recibí de:">
                                <b-form-input v-model="datos_editar.recibide"></b-form-input>
                            </b-form-group>
                            </div>
                            <div class="col-md-6 text-left">
                            <b-form-group label="Asignación:">
                                <select v-model="datos_editar.asignacion" class="form-control">
                                <option disabled value="">Seleccione una opción</option>
                                <option v-for="(u, i) in users.filter(u=>u.rol=='Vendedor')" :key="i" :value="u.name">{{u.name}}</option>
                            </select>
                            </b-form-group>
                        </div>
                        <div class="col-md-12 text-left">
                            <label>Por Concepto de:</label>
                            <div class="row text-center mt-3 ocultar" v-if="datos_editar.facturas.length>0">
                                <div class="col-md-3 p-1">
                                    <label>Nº Factura</label>
                                </div>
                                <div class="col-md-2 p-1">
                                    <label>Monto</label>
                                </div>
                                <div class="col-md-2 p-1">
                                    <label>Paga</label>
                                </div>
                                <div class="col-md-3 p-1">
                                    <label>Fecha</label>
                                </div>
                                <div class="col-md-1"></div>
                            </div>
                            <div v-for="(factura, index) in datos_editar.facturas" :key="index">
                                <div class="row">
                                    <div class="col-md-3 p-1">
                                        <label class="ocultar-lg">Nº Factura</label>
                                        <b-form-input v-model="factura.concepto"></b-form-input>
                                    </div>
                                    <div class="col-md-2 p-1">
                                        <label class="ocultar-lg">Monto</label>
                                        <b-form-input v-model="factura.valor"></b-form-input>
                                    </div>
                                    <div class="col-md-2 p-1">
                                        <label class="ocultar-lg">Paga</label>
                                        <p class="form-control" :class="factura.pago==factura.valor?'border-success bg-success-light':'border-danger bg-danger-light'">
                                            {{ formatNumber(factura.pago) }}
                                        </p>
                                    </div>
                                    <div class="col-md-3 p-1">
                                        <label class="ocultar-lg">Fecha</label>
                                        <b-form-input type="date" v-model="factura.fecha"></b-form-input>
                                    </div>
                                    <div class="col-md-1">
                                        <b-button variant="danger" @click="eliminar_editar(index)"><i class="bx bx-trash"></i></b-button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 text-center">
                                    <b-button variant="primary" size="sm" @click="factura_editar()">Agregar concepto</b-button>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div class="row mt-3">
                        <div class="col-md-12 text-left">
                            <h5>Medios de Pago</h5>
                            <b-form-checkbox-group stacked v-model="datos_editar.pago" @change="cambio_pago_editar">
                            <b-form-checkbox value="efectivo">Efectivo</b-form-checkbox>
                            <div class="row" v-if="datos_editar.pago.includes('efectivo')">
                                <div class="col-md-4">
                                <b-form-group label="Monto :"><b-form-input v-model="datos_editar.mediopago.montoefectivo"></b-form-input></b-form-group>
                                </div>
                            </div>
                            <b-form-checkbox value="cheque">Cheque</b-form-checkbox>
                            <div class="row mb-2" v-for="(ch, i) in datos_editar.mediopago.cheque" :key="i" v-show="datos_editar.pago.includes('cheque')">
                                <div class="col-md-2"><b-form-group label="Nº :"><b-form-input v-model="ch.n"></b-form-input></b-form-group></div>
                                <div class="col-md-3"><b-form-group label="Banco :"><b-form-input v-model="ch.banco"></b-form-input></b-form-group></div>
                                <div class="col-md-3"><b-form-group label="Monto :"><b-form-input v-model="ch.montocheque"></b-form-input></b-form-group></div>
                                <div class="col-md-3"><b-form-group label="Fecha :"><b-form-input type="date" v-model="ch.fecha"></b-form-input></b-form-group></div>
                                <div class="col-md-1 mt-3 pt-1"><b-button variant="danger" @click="datos_editar.mediopago.cheque.splice(i,1)"><i class="bx bx-trash"></i></b-button></div>
                            </div>
                            <div class="row" v-if="datos_editar.pago.includes('cheque')">
                                <div class="col-md-12 text-center">
                                <b-button variant="primary" size="sm" @click="datos_editar.mediopago.cheque.push({ n:'',banco:'',montocheque:'',fecha:'' })">Agregar cheque</b-button>
                                </div>
                            </div>
                            <b-form-checkbox value="tarjeta">Tarjeta</b-form-checkbox>
                            <div class="row mb-2" v-if="datos_editar.pago.includes('tarjeta')">
                                <div class="col-md-12">
                                <b-form-radio-group v-model="datos_editar.mediopago.tipotarjeta">
                                    <b-form-radio value="credito">Crédito</b-form-radio>
                                    <b-form-radio value="debito">Débito</b-form-radio>
                                </b-form-radio-group>
                                </div>
                                <div class="col-md-4">
                                <b-form-group label="Monto :"><b-form-input v-model="datos_editar.mediopago.montotarjeta"></b-form-input></b-form-group>
                                </div>
                            </div>
                            <b-form-checkbox value="webpay">Webpay</b-form-checkbox>
                            <div class="row mb-2" v-if="datos_editar.pago.includes('webpay')">
                                <div class="col-md-12">
                                <b-form-radio-group v-model="datos_editar.mediopago.tipowebpay">
                                    <b-form-radio value="credito">Crédito</b-form-radio>
                                    <b-form-radio value="debito">Débito</b-form-radio>
                                </b-form-radio-group>
                                </div>
                                <div class="col-md-4">
                                <b-form-group label="Monto :"><b-form-input v-model="datos_editar.mediopago.montowebpay"></b-form-input></b-form-group>
                                </div>
                            </div>
                            <b-form-checkbox value="transferencia">Transferencia</b-form-checkbox>
                            <div class="row" v-if="datos_editar.pago.includes('transferencia')">
                                <div class="col-md-4"><b-form-group label="Monto :"><b-form-input v-model="datos_editar.mediopago.montotransferencia"></b-form-input></b-form-group></div>
                            </div>
                            <b-form-checkbox value="excedente">Excedente anterior</b-form-checkbox>
                            <div class="row" v-if="datos_editar.pago.includes('excedente')">
                                <div class="col-md-4"><b-form-group label="Monto :"><b-form-input v-model="datos_editar.mediopago.montoexcedente"></b-form-input></b-form-group></div>
                            </div>
                            </b-form-checkbox-group>
                        </div>
                        <div class="offset-md-9 col-md-3 text-right">
                            <div class="input-group">
                            <div class="input-group-text bg-primary text-white">A Pagar</div>
                            <p class="form-control">{{ formatNumber(aPagar_editar) }}</p>
                            </div>
                            <br>
                            <div class="input-group">
                            <div class="input-group-text bg-blue-light text-white">Saldo</div>
                            <p class="form-control">{{ formatNumber(aFavor_editar) }}</p>
                            </div>
                            <div class="input-group">
                            <div class="input-group-text bg-blue-light text-white">Total</div>
                            <p class="form-control">{{ formatNumber(sumaTotal_editar) }}</p>
                            </div>
                        </div>
                        </div>
                    </b-modal>
                    <b-modal ref="modal-contabilidad" title="Datos contabilidad" size="lg" ok-title="Guardar" cancel-title="Cancelar" @ok="validacion_contabilidad">
                        <div class="row">
                        <p v-if="contabilidad.bloqueado" class="col-md-12 text-danger"><strong>Cliente bloqueado: No olvide desbloquearlo.</strong></p>
                        <div class="col-md-6"><b-form-group label="Nº contable:"><b-form-input type="text" v-model="contabilidad.ncontable" :disabled="contabilidad.booln"></b-form-input></b-form-group></div>
                        <div class="col-md-6"><b-form-group label="Fecha contable:"><b-form-input type="date" v-model="contabilidad.fechacontable" :disabled="contabilidad.boolfecha"></b-form-input></b-form-group></div>
                        <div class="col-md-12 text-left" v-if="contabilidad.asignacion=='SALA DE VENTASS'">
                            <b-form-checkbox v-model="contabilidad.selectAll" @change="toggleAll">Seleccionar todo</b-form-checkbox>
                            <div class="table-responsive">
                            <table class="table table-hover mb-0">
                                <thead>
                                <tr>
                                    <th style="width:4%;"></th>
                                    <th style="width:4%;">Nº</th>
                                    <th style="width:8%;">Rut</th>
                                    <th style="width:20%;">Recibí de</th>
                                    <th style="width:5%;">Total</th>
                                    <th style="width:10%;">Tipo de pago</th>
                                    <th style="width:8%;">Fecha</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(r) in contabilidad.mismos" :key="r.id">
                                    <th><b-form-checkbox :value="r.id" v-model="contabilidad.arreglo" @change="checkIfAllSelected" :disabled="r.id==contabilidad.id"></b-form-checkbox></th>
                                    <td>{{ r.id }}</td><td>{{ r.rut }}</td><td>{{ r.recibide }}</td>
                                    <td>{{ formatNumber(r.suma) }}</td>
                                    <td><p class="m-0" v-for="(p,ip) in r.pago" :key="ip">{{ p }}</p></td>
                                    <td>{{ fecha(r.fecha) }}</td>
                                </tr>
                                </tbody>
                            </table>
                            </div>
                            <div class="float-right">
                            <div class="input-group">
                                <div class="input-group-text bg-primary text-white">Total</div>
                                <p class="form-control">{{ formatNumber(suma) }}</p>
                            </div>
                            </div>
                        </div>
                        </div>
                    </b-modal>
                    <div class="row mt-5">
                        <h4 :class="windowWidth2>576?'col-md-12':'col-md-12 mb-4'">Recibos Contabilizados</h4>
                        <div class="col-md-12 text-center">
                            <b-form-radio-group v-model="selected" :options="options" button-variant="outline-primary" size="lg" name="radio-btn-outline" buttons @change="filtro_tabla"></b-form-radio-group>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-sm-12 col-md-6 mt-2">
                            <div class="dataTables_length">
                                <label class="d-inline-flex align-items-center">
                                Mostrar&nbsp;<b-form-select v-model="perPage2" size="sm" :options="pageOptions2"></b-form-select>&nbsp;recibos
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-2">
                            <div class="dataTables_filter text-md-right">
                                <label class="d-inline-flex align-items-center">
                                Buscar: <b-form-input v-model="filtro2" type="search" placeholder="Buscar..." class="form-control form-control-sm ml-2"></b-form-input>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive mb-0 mt-3">
                        <table class="table table-hover">
                        <thead>
                            <tr>
                            <th class="ocultar" style="width:5%;">Nº</th>
                            <th class="ocultar" style="width:8%;">Nº Contable</th>
                            <th style="width:11%;">Fecha</th>
                            <th class="ocultar" style="width: 10%;">Creado por</th>
                            <th class="ocultar" style="width:10%;">RUT</th>
                            <th style="width:30%;">Recibi</th>
                            <!-- <th style="width:10%;">Total</th> -->
                            <th class="ocultar" style="width:10%;">Tipo de Pago</th>
                            <th class="ocultar" style="width:10%;">Asignación</th>
                            <th style="width:20%;">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in paginatedData2" :key="item.id">
                            <td class="ocultar">{{ item.id }}</td>
                            <td class="ocultar">{{ item.ncontable }}</td>
                            <td>{{ item.fechaComprobante }}</td>
                            <td class="ocultar">{{ usersAll.find(u=>u.id==item.creado_user_id)?.name||'' }}</td>
                            <td class="ocultar">{{ item.rut }}</td>
                            <td>{{ item.recibide }}</td>
                            <!-- <td>{{ formatNumber(item.suma) }}</td> -->
                            <td class="ocultar"><p class="m-0" v-for="(p,i) in item.pago" :key="i">{{ p }}</p></td>
                            <td class="ocultar">{{ item.asignacion }}</td>
                            <td>
                                <b-button variant="primary" @click="ver_modal(item)" size="sm"><i class="bx bx-show font-size-14"></i></b-button>
                                <!-- <b-button variant="primary" @click="editar_modal(item)" size="sm" v-if="user.rol=='Admin'">Editar</b-button> -->
                                <!-- <b-button variant="danger" @click="modal_obs(item)" size="sm" v-if="item.estado=='vigente'">Anular.</b-button>
                                <b-button 
                                    variant="danger" 
                                    @click="modal_obs(item)" 
                                    size="sm" 
                                    :disabled="!item.estado === 'vigente' && !esUltimoRecibo(item)"
                                >
                                    Anular
                                </b-button> -->
                                
                                <b-button variant="primary" @click="modal_ver_obs(item)" size="sm" v-if="item.observacion!=null">Obervacion</b-button>
                            </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                    <div class="row">
                        <div class="col">
                          <div class="float-right">
                              <b-pagination v-model="currentPage2" :total-rows="rows2" :per-page="perPage2"></b-pagination>
                          </div>
                        </div>
                    </div>
                    <b-modal ref="modal-ver" no-close-on-backdrop title="Ver Recibo Digital" size="lg">
                        <div class="row" ref="ReciboContentPDF">
                            <div class="col-md-12 p-5">
                                <div class="col-md-12 mt-3 mb-3">
                                    <div class="row" style="display: flex; justify-content: space-between; align-items: center;">
                                        <!-- Texto alineado a la izquierda -->
                                        <div class="col-md-7" style="text-align: left; padding-left: 0; padding-right: 0;">
                                            <img src="/archivos_base/logo.png" style="height: 50px; object-fit: contain;">
                                            <p class="text-primary mt-2">
                                                <strong>Teléfono:</strong> 63 2 219881 - 63 2 204385<br>
                                                <strong>Dirección:</strong> Errázuriz 2066, Valdivia<br>
                                                <strong>Email: </strong>contacto@vamproden.cl<br>
                                                <strong>Dirección Web: </strong>www.vamproden.cl
                                            </p>
                                        </div>
                                        <!-- Imagen alineada a la derecha -->
                                        <div class="col-md-5 no-pdf" style="text-align: left; padding-left: 0; padding-right: 0;">
                                            <p class="text-primary"><b>CI:</b> {{ info.id }}</p>
                                            <!-- <p>{{ info.facturas?.forEach(element => {
                                              element.revisado
                                            }) }}</p> -->
                                            <p class="text-primary">
                                                <b>Nº Contable:</b>
                                                {{ info.ncontable }}
                                                <b-button class="text-danger" size="sm" variant="link" @click="agregar_input" v-if="(info.ncontable==null || mostrar_boton) && (user.rol=='Admin' || user.id==6) " :disabled="info.facturas?.some(factura => !factura.revisado)">Agregar aqui</b-button>
                                            </p>
                                            <b-form-input type="text" size="sm" v-model="contabilidad_ver.ncontable" :disabled="contabilidad.booln" v-if="mostrar"></b-form-input>
                                            <p class="text-primary">
                                                <b>Fecha Contable:</b> 
                                                {{ info.fechacontable?fecha(info.fechacontable):'' }}
                                            </p>
                                            <b-form-input type="date" size="sm" v-model="contabilidad_ver.fechacontable" :disabled="contabilidad.boolfecha" v-if="mostrar"></b-form-input>
                                            <b-button class="float-right" size="sm" variant="primary" @click="vali_contabilidad" v-if="mostrar">Contabilizar</b-button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 mt-3 mb-2">
                                    <div class="row" style="display: flex; flex-direction: column; align-items: flex-start;">
                                        <h3 class="text-primary" style="margin-top: 10px;">COMPROBANTE DE INGRESOS</h3>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-2" style="text-align: left; padding-left: 0; padding-right: 0;">
                                    <div class="row border p-3 mb-3" style="background-color: #f8f9fa; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start; margin-left: 0; margin-right: 0;">
                                        <!-- Primera columna -->
                                        <div class="col-md-6" style="text-align: left; padding-left: 0; padding-right: 0;">
                                            <p class="text-primary">
                                                <b>Fecha Comprobante:</b> {{ fecha(info.created_at) }}<br>
                                                <b>Recibí de:</b> {{ capitalizarPrimeraLetra(info.recibide) }}<br>
                                                <b>Rut:</b> {{ info.rut }}
                                            </p>
                                        </div>
                                        <!-- Segunda columna -->
                                        <div class="col-md-6" style="text-align: left; padding-left: 0; padding-right: 0;">
                                            <p class="text-primary"><b>Generado por:</b> {{ usersAll.find(u=>u.id==info.creado_user_id)?.name || '' }}<br>
                                                <b>Estado:</b> {{ capitalizarPrimeraLetra(info.estado) }}<br>
                                                <b>Asignación:</b> {{ capitalizarPrimeraLetra(info.asignacion) }}
                                            </p>

                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-12 mb-2">
                                    <div class="row text-left">
                                        <div class="col-md-12" style="text-align: left; padding-left: 0; padding-right: 0;">
                                            <p style="color: #21308F;"><b>Por Concepto de: </b></p>

                                            <div class="table-responsive">
                                                <table class="table table-hover mb-0" style="border: 1px solid #21308F; border-collapse: collapse;">
                                                    <thead>
                                                        <tr style="background-color: #f8f9fa;">
                                                            <th class="no-pdf" v-if="user.rol=='Admin' || user.id==6" style="border: 1px solid #21308F;">Check</th>
                                                            <th style="border: 1px solid #21308F;">Nº Factura</th>
                                                            <th style="border: 1px solid #21308F;">Monto</th>
                                                            <th style="border: 1px solid #21308F;">Pago</th>
                                                            <th style="border: 1px solid #21308F;">Vencimiento</th>
                                                            <th class="no-pdf" style="border: 1px solid #21308F;">Estado</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(factura, index) in info.facturas" :key="index" :class="factura.revisado ? 'table-success' : ''">
                                                            <td v-if="user.rol=='Admin' || user.id==6" class="no-pdf" style="border: 1px solid #21308F;">
                                                                <b-form-checkbox v-model="factura.revisado" :disabled="info.ncontable"></b-form-checkbox>
                                                            </td>
                                                            <td scope="row" style="border: 1px solid #21308F;">{{ factura.concepto }}</td>
                                                            <td style="border: 1px solid #21308F;">{{ formatNumber(factura.valor) }}</td>
                                                            <td style="border: 1px solid #21308F;">{{ formatNumber(factura.pago) }}</td>
                                                            <td style="border: 1px solid #21308F;">{{ factura.fecha }}</td>
                                                            <td class="no-pdf" style="border: 1px solid #21308F;"><strong class="text-danger">{{ factura.cli_estado }}</strong></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 mt-4 mb-4" v-if="info.pago && info.pago.length>0">
                                    <div class="row" style="display: flex; justify-content: space-between; align-items: center;">
                                        <!-- Texto alineado a la izquierda -->
                                        <div class="col-md-6 pr-4" style="text-align: left; padding-left: 0; padding-right: 0;">
                                            <p class="text-primary"><b>Fecha Pago:</b> {{ fecha(info.fecha) }}</p>
                                            <p class="text-primary mt-2"><b>Medio de pago utilizado:</b></p>

                                            <!-- Pago en efectivo -->
                                            <p class="text-primary col-12" v-if="info.pago.includes('efectivo')">
                                                <b><u>Efectivo:</u></b> {{ info.mediopago.montoefectivo }}
                                            </p>

                                            <!-- Pago con cheque -->
                                            <p class="text-primary col-12" v-if="info.pago.includes('cheque')">
                                                <b><u>Cheque:</u></b>
                                            </p>
                                            <div class="row"  v-if="info.pago.includes('cheque')">
                                              <div class="table-responsive">
                                                <table class="table table-hover mb-0">
                                                  <thead>
                                                    <tr>
                                                      <th class="text-primary">Nº</th>
                                                      <th class="text-primary">Monto</th>
                                                      <th class="text-primary">Información</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                      <tr v-for="(cheque, index) in info.mediopago.cheque" :key="index">
                                                        <td class="text-primary">{{ cheque.n }}</td>
                                                        <td class="text-primary">{{ formatNumber(cheque.montocheque) }}</td>
                                                        <td class="text-primary">{{ capitalizarPrimeraLetra(cheque.banco) }}<br>
                                                          {{ fecha(cheque.fecha) }}
                                                        </td>
                                                      </tr>
                                                    
                                                  </tbody>
                                                </table>
                                              </div>
                                                <!-- <p class="text-primary col-2" v-if="info.pago.includes('cheque')">
                                                    <b>Nº:</b> {{ cheque.n }}
                                                </p>
                                                <p class="text-primary col-4" v-if="info.pago.includes('cheque')">
                                                    <b>Banco:</b> {{ capitalizarPrimeraLetra(cheque.banco) }}
                                                </p>
                                                <p class="text-primary col-6" v-if="info.pago.includes('cheque')">
                                                    <b>Fecha:</b> {{ fecha(cheque.fecha) }}
                                                </p> -->
                                            </div>
                                            <!-- Pago con tarjeta -->
                                            <p class="text-primary col-12" v-if="info.pago.includes('tarjeta')">
                                                <b><u>Tarjeta: </u></b>{{ info.mediopago.montotarjeta }} / {{ info.mediopago.montotransferencia }}
                                            </p>
                                            <p class="text-primary col-12" v-if="info.pago.includes('tarjeta')">
                                                {{ capitalizarPrimeraLetra(info.mediopago.tipotarjeta) }}
                                            </p>
                                            <!-- Pago con Webpay -->
                                            <p class="text-primary col-12" v-if="info.pago.includes('webpay')">
                                                <b><u>Webpay:</u></b> {{ info.mediopago.montowebpay }}
                                            </p>
                                            <p class="text-primary col-12" v-if="info.pago.includes('webpay')">
                                                {{ capitalizarPrimeraLetra(info.mediopago.tipowebpay) }}
                                            </p>
                                            <!-- Pago por transferencia -->
                                            <p class="text-primary col-12" v-if="info.pago.includes('transferencia')">
                                                <b><u>Transferencia:</u></b> {{ info.mediopago.montotransferencia }}
                                            </p>
                                            <!-- Pago excedente -->
                                            <p class="text-primary col-12" v-if="info.pago.includes('excedente')">
                                                <b><u>Excedente:</u></b> {{ info.mediopago.montoexcedente }}
                                            </p>
                                        </div>
                                        <!-- Imagen alineada a la derecha -->
                                        <div class="col-md-6" style="text-align: left; padding-left: 0; padding-right: 0;">
                                            <div class="border p-3 mb-3" style="background-color: #f8f9fa;">
                                                <p class="text-primary mb-1"><b>Total facturas:</b> <span class="font-weight-bold">{{ formatNumber(info.suma) }}</span></p>
                                                <p class="text-primary mb-1"><b>Total abonado:</b> <span class="font-weight-bold">{{ formatNumber(info.pago_sin_exedente) }}</span></p>
                                                <p class="text-primary mb-1"><b>Total recibo (Incluye excedentes):</b> <span class="font-weight-bold">{{ formatNumber(info.aPagar) }}</span></p>
                                                <p class="text-primary mb-1"><b>Excedente a favor acumulado:</b> <span class="font-weight-bold">{{ formatNumber(info.aFavor) }}</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <template #modal-footer>
                              <div class="row" v-if="windowWidth2<576">
                                <div class="col-md-10 col-sm-12">
                                  <b-button v-if="true" class="float-left mr-1" variant="primary" @click="generarPDF(info)">
                                    <i class="bx bxs-file-pdf font-size-16 mr-1"></i> Descargar PDF
                                  </b-button>
                                  <b-button v-if="true" class="float-left" variant="primary" @click="consultaCorreo(info)">
                                    <!-- enviarPDF(info) -->
                                      <i class="bx bxs-file-pdf font-size-16 mr-1"></i> Enviar PDF
                                  </b-button>
                                </div>
                                <div class="col-md-2 col-sm-12  mt-2">
                                  <b-button class="float-right" variant="primary" block @click="handleAceptar(info)">
                                      Aceptar
                                  </b-button>
                                </div>
                              </div>
                              <div class="w-100" v-else>
                                <b-button v-if="true" class="float-left mr-1" variant="primary" @click="generarPDF(info)">
                                    <i class="bx bxs-file-pdf font-size-16 mr-1"></i> Descargar PDF
                                  </b-button>
                                  <b-button v-if="true" class="float-left" variant="primary" @click="consultaCorreo(info)">
                                    <!-- enviarPDF(info) -->
                                      <i class="bx bxs-file-pdf font-size-16 mr-1"></i> Enviar PDF
                                  </b-button>
                                  <b-button class="float-right" variant="primary" @click="handleAceptar(info)">
                                      Aceptar
                                  </b-button>
                              </div>
                              <!-- comentado descargar pdf -->
                                
                        </template>
                    </b-modal>
                    <b-modal ref="modal-obs" no-close-on-backdrop title="Observación" ok-title="Guardar" cancel-title="Cancelar" @ok="obser">
                        <b-form-textarea v-model="obs.observacion" rows="3" max-rows="6"></b-form-textarea>
                    </b-modal>
                    <b-modal ref="modal-ver-obs" no-close-on-backdrop title="Observación" ok-only ok-title="Aceptar">
                        <h4>{{ ver.observacion }}</h4>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</Layout>
</template>

<style scoped>
@media (max-width: 992px) {
    .ocultar {
        display: none;
    }
}
@media (min-width: 992px) {
    .ocultar-lg {
        display: none;
    }
}
.border-success {
    border: 2px solid green;
}
.bg-success-light {
    background-color: #d4edda; /* Verde claro */
}

.border-danger {
    border: 2px solid red;
}
.bg-danger-light {
    background-color: #f8d7da; /* Rojo claro */
}
.hide-elements .no-pdf {
    display: none !important;
}
</style>